import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Api } from '../../api'
import type { Feature } from '../feature'

/** Deletes the confirmed document. */
export const executeDelete = store.effects.create(
  (feature: Feature, api: Api) =>
    feature.actions.delete.request.observe().pipe(
      rxjs.exhaustMap(action =>
        api
          .deleteFile({
            dataSourceId: action.data.dataSourceId,
            key: action.data.key,
            knowledgeBaseId: action.data.knowledgeBaseId,
          })
          .pipe(
            rxjs.map(() =>
              feature.actions.delete.success.from(action).create({
                request: action.data,
                response: undefined,
              }),
            ),
            rxjs.catchError((error: Error) =>
              rxjs.of(
                feature.actions.delete.error.from(action).create({
                  error,
                  request: action.data,
                }),
              ),
            ),
          ),
      ),
    ),
)
